/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
//fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

( function () {
	( function ( $ ) {
        $.fn.resizeselect = function(settings) {
        return this.each(function(){
            var $this = $(this), numberOfOptions = $(this).children('option').length;
        
            $this.addClass('select-hidden'); 
            $this.wrap('<div class="select"></div>');
            $this.after('<div class="select-styled"></div>');
        
            var $styledSelect = $this.next('div.select-styled');
            $styledSelect.text($this.find(":selected") ? $this.find(":selected").text() : $this.children('option').eq(0).text());
        
            var $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);
        
            for (var i = 0; i < numberOfOptions; i++) {
                if(i!=0){
                    $('<li />', {
                        text: $this.children('option').eq(i).text(),
                        rel: $this.children('option').eq(i).val(),
                        class: $this.children('option').eq(i).attr('selected') ? 'active' : '',
                    }).appendTo($list);
                }
            }
        
            var $listItems = $list.children('li');
        
            $styledSelect.click(function(e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function(){
                    $(this).removeClass('active').next('ul.select-options').hide();
                });
                $(this).toggleClass('active').next('ul.select-options').toggle();
            });
        
            $listItems.click(function(e) {
                e.stopPropagation();
                $styledSelect.text($(this).text()).removeClass('active');
                $this.val($(this).attr('rel'));
                $list.hide();
                $this.trigger('change');
            });
        
            $(document).click(function() {
                $styledSelect.removeClass('active');
                $list.hide();
            });
        });
    }
    $( window ).on( "load", function() {
        if($('.fixtures-detail').length > 0){
                var fcatid = 'all';
                $("#loaders").show();
                $.ajax({
                    type: "POST",
                    cache: false,
                    url: ssAjax.ajaxurl,
                    data: { nonce: ssAjax.nonce, fcatid:fcatid, action: 'getfixturesdata' },
                    dataType: 'html',
                    success: function (response) {
                       // console.warn(response);
                        $("#loaders").fadeOut();
                        $("#datapritn").html("");
                        $("#datapritn").html(response);
                    }
                });
        }
      
    });
    if($('.fixtures-detail').length > 0){
        $('.fixtures-right-tab#men1').click(function() {
            $(".fixtures-last-tab").removeClass('active');
            $("#all-match-1").addClass('active');
            $(".fixtures-last-tab-content").removeClass('active');
              
            var fcatid = 'all';
                $("#loaders").show();
                $.ajax({
                    type: "POST",
                    cache: false,
                    url: ssAjax.ajaxurl,
                    data: { nonce: ssAjax.nonce, fcatid:fcatid, action: 'getfixturesdata' },
                    dataType: 'html',
                    success: function (response) {
                       // console.warn(response);
                        $("#loaders").fadeOut();
                        $("#datapritn").html("");
                        $("#datapritn").html(response);
                    }
                });
            
           
        });
        $('.fixtures-right-tab#women').click(function() {
            $(".fixtures-women-tab").removeClass('active');
            $("#all-match-2").addClass('active');
            $(".fixtures-last-tab-content").removeClass('active');
            var fcatid = 'all-woman';
                $("#loaderswoman").show();
                $.ajax({
                    type: "POST",
                    cache: false,
                    url: ssAjax.ajaxurl,
                    data: { nonce: ssAjax.nonce, fcatid:fcatid, action: 'getfixturesdata' },
                    dataType: 'html',
                    success: function (response) {
                       // console.warn(response);
                        $("#loaderswoman").fadeOut();
                        $("#datapritnwoman").html("");
                        $("#datapritnwoman").html(response);
                    }
                });
            
           
        });
        $('.fixtures-last-tab.fixtu').click(function() {
            var fcatid = $(this).data("id");
            $("#loaders").show();
            $.ajax({
                type: "POST",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, fcatid:fcatid, action: 'getfixturesdata' },
                dataType: 'html',
                success: function (response) {
                   // console.warn(response);
                    $("#loaders").fadeOut();
                    $("#datapritn").html("");
                    $("#datapritn").html(response);
                }
            });
        });
        $('.fixtures-women-tab.fixtu').click(function() {
            var fcatid = $(this).data("id");
            $("#loaderswoman").show();
            $.ajax({
                type: "POST",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, fcatid:fcatid, action: 'getfixturesdata' },
                dataType: 'html',
                success: function (response) {
                   // console.warn(response);
                    $("#loaderswoman").fadeOut();
                    $("#datapritnwoman").html("");
                    $("#datapritnwoman").html(response);
                }
            });
        });
        $('.fixtures-tables-tab.tables').click(function() {
            var compid = $(this).data("id");
            $(".loaders").show();
            $.ajax({
                type: "POST",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, compid:compid, action: 'gettablesdata' },
                dataType: 'html',
                success: function (responses) {
                   // console.warn(response);
                    $(".loaders").fadeOut();
                    $(".fixtures-tab-detail").addClass('active');
                    $("#fixtable").html("");
                    $("#fixtable").html(responses);
                }
            });
        });
        $('.ftabel').click(function() {
            var compid ='8133';
            $(".loaders").show();
            $.ajax({
                type: "POST",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, compid:compid, action: 'gettablesdata' },
                dataType: 'html',
                success: function (responses) {
                   // console.warn(response);
                    $(".loaders").fadeOut();
                    $(".fixtures-tab-detail").addClass('active');
                    $("#fixtable").html("");
                    $("#fixtable").html(responses);
                }
            });
        });
        // $('.resu').click(function() {
            
        //     $(".loaders").show();
        //     $.ajax({
        //         type: "GET",
        //         cache: false,
        //         url: ssAjax.ajaxurl,
        //         data: { nonce: ssAjax.nonce, action: 'getresultdata' },
        //         dataType: 'html',
        //         success: function (responses) {
        //            // console.warn(response);
        //             $(".loaders").fadeOut();
        //             //$(".fixtures-tab-detail").addClass('active');
        //              $("#datapritntable").html("");
        //              $("#datapritntable").html(responses);
        //         }
        //     });
        // });
        $('.fixtures-results-tab').click(function() {
            var fcatid = $(this).data("id");
            $("#loaders").show();
            $.ajax({
                type: "POST",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, fcatid:fcatid, action: 'getresultdata' },
                dataType: 'html',
                success: function (response) {
                   // console.warn(response);
                    $("#loaders").fadeOut();
                    $("#datapritntable").html("");
                    $("#datapritntable").html(response);
                }
            });
        });
    }
    
    $('.products.columns-4').slick({
        dots:false,
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay:true,
        autoplaySpeed: 2000,
        // adaptiveHeight: true,
        arrows:true,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                }
            }
        ]
    });
    // $('.match-slider-live').slick({
    //     dots:true,
    //     infinite: true,
    //     speed: 800,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     autoplay:true,
    //     autoplaySpeed: 5000,
    //     arrows:false,
    //     responsive: [
    //         {
    //             breakpoint: 1023,
    //             settings: {
    //               slidesToShow: 1,
    //             }
    //         },
    //         {
    //             breakpoint: 767,
    //             settings: {
    //               slidesToShow: 1,
    //             }
    //         }
    //     ]
    // });
   
    if($('.match-slider-live').length){
       
        // initializeSlickSlider();
        $('.loaderlive').show();
        var url = window.location.href; 
        $(".live-match-widgetx").each(function(){
            var $widget = $(this);
            var matchid = $widget.data('matchid');
            var matchtype = $widget.data('type'); // Get the match type (men/women)
            
            // Make AJAX request for each widget
            $.ajax({
                type: "GET",
                cache: false,
                url: ssAjax.ajaxurl, // Correct AJAX URL
                dataType: 'html',
                data: { 
                    nonce: ssAjax.nonce, 
                    matchid: matchid, 
                    action: 'getlivewidget2' 
                },
                success: function (responses) {
                    $widget.find('.loaderlive').hide();
        
                    // Append the match type dynamically to the response
                    var updatedHTML = `<div data-type="${matchtype}">${responses}</div>`;
                    $widget.html(updatedHTML);
                    $widget.addClass('loaded');
        
                    var mcval = $('.mstus').val();
                    if (mcval === 'live') {
                        // Refresh live widget every minute
                        setInterval(function () {
                            $widget.find('.loaderlive').show();
                            $.ajax({
                                type: "GET",
                                cache: false,
                                url: ssAjax.ajaxurl,
                                dataType: 'html',
                                data: { 
                                    nonce: ssAjax.nonce, 
                                    matchid: matchid, 
                                    action: 'getlivewidget2'
                                },
                                success: function (responses) {
                                    $widget.find('.loaderlive').hide();
        
                                    // Append the match type dynamically to the response
                                    var refreshedHTML = `<div data-type="${matchtype}">${responses}</div>`;
                                    $widget.html(refreshedHTML);
                                }
                            });
                        }, 60000); // Update every 60 seconds
                    }
                },
                error: function () {
                    $widget.find('.loaderlive').hide();
                    $widget.html('<p>Failed to fetch live data. Please try again later.</p>');
                }
            });

        });
       
    }
    if($('.matchcenter-hero-banner-bottom').length > 0){
        $('#moments').on('change', function() {
             var selectedid = $(this).val();
             $('.listmoment').addClass('hide');
             $('#'+selectedid).removeClass('hide');
        });
    }
    if($('.api-match-center').length){
        var mtatus = $('.matchsatus').val();
        if(mtatus != 'notdone'){
                var url = window.location.href; 
                $.ajax({
                    type: "GET",
                    cache: false,
                    url: url,
                    dataType: 'html',
                    success: function (responses) {
                        var doc = new DOMParser().parseFromString(responses, 'text/html');
                        var cteam = $('.cteam').val();
                        var cinning = $('.cinning').val();
                        var replaceclass = '.tables-'+cteam+'-'+cinning;
                        
                        var resultHtml = $(doc).find('.banneronerun').html();
                        var filterHtml = $(doc).find('.bannertworun').html();
                        var summonerunHtml = $(doc).find('.summonerun').html();
                        var summtworunHtml = $(doc).find('.summtworun').html();
                        var bbbHtml = $(doc).find('.bbbdata').html();
                        var commentHtml = $(doc).find('.commentary-detail-section').html();
                        var summdetailsHtml = $(doc).find('.summdetials').html();
                        var roverHtml = $(doc).find('.remaingover').html();
                        //var blogsHtml = $(doc).find('.lvblog').html();
                        
                        
                        
                        
                        var tableHtml = $(doc).find(replaceclass).html();
                
                        $('.banneronerun').html(resultHtml);
                        $('.bannertworun').html(filterHtml);
                        $('.summonerun').html(summonerunHtml);
                        $('.summtworun').html(summtworunHtml);
                        $('.bbbdata').html(bbbHtml);
                        $(replaceclass).html(tableHtml);
                        $('.commentary-detail-section').html(commentHtml);
                        $('.summdetials').html(summdetailsHtml);
                        $('.remaingover').html(roverHtml);
                        
                       // $('.lvblog').html(blogsHtml);
                        
    
                    }
                });
           
        }
        else{
            setInterval(function(){
                var url = window.location.href; 
                $.ajax({
                    type: "GET",
                    cache: false,
                    url: url,
                    dataType: 'html',
                    success: function (responses) {
                        var doc = new DOMParser().parseFromString(responses, 'text/html');
                        var cteam = $('.cteam').val();
                        var cinning = $('.cinning').val();
                        var replaceclass = '.tables-'+cteam+'-'+cinning;
                        
                        var resultHtml = $(doc).find('.banneronerun').html();
                        var filterHtml = $(doc).find('.bannertworun').html();
                        var summonerunHtml = $(doc).find('.summonerun').html();
                        var summtworunHtml = $(doc).find('.summtworun').html();
                        var bbbHtml = $(doc).find('.bbbdata').html();
                        var commentHtml = $(doc).find('.commentary-detail-section').html();
                        var summdetailsHtml = $(doc).find('.summdetials').html();
                        var roverHtml = $(doc).find('.remaingover').html();
                        //var blogsHtml = $(doc).find('.lvblog').html();
                        
                        
                        
                        
                        var tableHtml = $(doc).find(replaceclass).html();
                
                        $('.banneronerun').html(resultHtml);
                        $('.bannertworun').html(filterHtml);
                        $('.summonerun').html(summonerunHtml);
                        $('.summtworun').html(summtworunHtml);
                        $('.bbbdata').html(bbbHtml);
                        $(replaceclass).html(tableHtml);
                        $('.commentary-detail-section').html(commentHtml);
                        $('.summdetials').html(summdetailsHtml);
                        $('.remaingover').html(roverHtml);
                        
                       // $('.lvblog').html(blogsHtml);
                        
    
                    }
                });
           },60000);  
        }

             
       //setInterval(function(){
        var url = window.location.href; 
        $.ajax({
            type: "GET",
            cache: false,
            url: url,
            dataType: 'html',
            success: function (responses) {
                var doc = new DOMParser().parseFromString(responses, 'text/html');
                var cteam = $('.cteam').val();
                var cinning = $('.cinning').val();
                var replaceclass = '.tables-'+cteam+'-'+cinning;
              
                var blogsHtml = $(doc).find('.lvblog').html();
               
                $('.lvblog').html(blogsHtml);
                
                $('.lmb').on('click', function(e) {
                    
                    var pageid = $('#lmid').val();
                    var totaqls = $('#lmid').data("id");
                    if(pageid != ''){
                        $.ajax({
                            type: "GET",
                            cache: false,
                            url: ssAjax.ajaxurl,
                            data: { nonce: ssAjax.nonce, pageid:pageid, action: 'getblogslists' },
                            dataType: 'json',
                            success: function (responses) {
                                // console.warn(responses.html);
                                 var newnext = responses.max;
                                 newnext++;
                                 //console.warn(newnext);
                                if(totaqls >= newnext){
                                    $("#lmid").val(newnext);
                                }
                                else{
                                    
                                    $(".loadmore-news-wrap").hide();
                                }
                                
                                $(".newblocs").append(responses.html);
                              
                            }
                        });
                    }
            
                    
                });
            }
        });
   //},600000);        
    }    
    if($('.live-blog-box').length > 0){
        
        
        $(document).on('click','.like',function(e) {
            e.preventDefault();
            var is_login = $.cookie("wps_uid");
            if(is_login != ''){
                var blogid = $(this).data("id");
            
                var namec = '.lcounts-'+blogid;
                $('.likes-'+blogid).html('wait..');
                $.ajax({
                    type: "POST",
                    cache: false,
                    url: ssAjax.ajaxurl,
                    data: { nonce: ssAjax.nonce, blogid:blogid, action: 'getlike' },
                    dataType: 'html',
                    success: function (responses) {
                        console.warn(blogid);
                        
                        $('.likes-'+blogid).html(responses);
                    }
                });
            }
            else{
                toastr.options = {
                    "closeButton": true,
                    "debug": false,
                    "newestOnTop": false,
                    "progressBar": true,
                    "positionClass": "toast-top-center",
                    "preventDuplicates": false,
                    "onclick": null,
                    "showDuration": "300",
                    "hideDuration": "1000",
                    "timeOut": "5000",
                    "extendedTimeOut": "1000",
                    "showEasing": "swing",
                    "hideEasing": "linear",
                    "showMethod": "fadeIn",
                    "hideMethod": "fadeOut"
                  }
                  toastr["error"]('Please log in to continue')
            }
        });
        
        $(document).on('click','.dlike',function(e) {
            e.preventDefault();
            var is_login = $.cookie("wps_uid");
            if(is_login != ''){
                var blogid = $(this).data("id");
            
                var namec = '.lcounts-'+blogid;
                $('.dlikes-'+blogid).html('wait..');
                $.ajax({
                    type: "POST",
                    cache: false,
                    url: ssAjax.ajaxurl,
                    data: { nonce: ssAjax.nonce, blogid:blogid, action: 'getdlike' },
                    dataType: 'html',
                    success: function (responses) {
                        console.warn(blogid);
                        $('.dlikes-'+blogid).html(responses);
                    }
                });
            }
            else{
                toastr.options = {
                    "closeButton": true,
                    "debug": false,
                    "newestOnTop": false,
                    "progressBar": true,
                    "positionClass": "toast-top-center",
                    "preventDuplicates": false,
                    "onclick": null,
                    "showDuration": "300",
                    "hideDuration": "1000",
                    "timeOut": "5000",
                    "extendedTimeOut": "1000",
                    "showEasing": "swing",
                    "hideEasing": "linear",
                    "showMethod": "fadeIn",
                    "hideMethod": "fadeOut"
                  }
                  toastr["error"]('Please log in to continue')
            }
        });
    }
    var visited = $.cookie("visited");
    //var pageid = $('#pids').val();
    var pageid = $('#adsid').val();
    if (visited == pageid) {
      $.cookie('visited', pageid, {
            expires: 365 // the number of days cookie  will be effective
        });
        $('.add-top-bottom-section').removeClass('show');
        // second page load, cookie active
    } else {
        $('.add-top-bottom-section').addClass('show');
      //openmagnific(); // first page load, launch fancybox
    }
    $('.add-top-bottom-close-icon').on('click', function(e) {
        e.preventDefault();
        $('.add-top-bottom-section').removeClass('show');
       // var pageid = $('#pids').val();
        var pageid = $('#adsid').val();
        visited = $.cookie("visited",pageid);
    });
    
    $('.cpylink').on('click', function(e) {
        e.preventDefault();
        var $temp = $("<input>");
        var $url = $(this).attr('href');
            $("body").append($temp);
            $temp.val($url).select();
            document.execCommand("copy");
            $temp.remove();            
    });

    
    $('.lmb').on('click', function(e) {
        var pageid = $('#lmid').val();
        var totaqls = $('#lmid').data("id");
        if(pageid != ''){
            $.ajax({
                type: "GET",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, pageid:pageid, action: 'getblogslists' },
                dataType: 'json',
                success: function (responses) {
                    // console.warn(responses.html);
                     var newnext = responses.max;
                     newnext++;
                     //console.warn(newnext);
                    if(totaqls >= newnext){
                        $("#lmid").val(newnext);
                    }
                    else{
                        
                        $(".loadmore-news-wrap").hide();
                    }
                    
                    $(".newblocs").append(responses.html);
                }
            });
        }

        
    });
    
    if($('.loadingpage').length){
        var pageid = $('#ids').val();
        if(pageid != ''){
            $.ajax({
                type: "POST",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, pageid:pageid, action: 'getsetuserdata' },
                dataType: 'html',
                success: function (responses) {
                    //console.warn(responses);
                    if(responses != 'nodata'){
                        var ArrNames = responses.split("^*");
                        var status = ArrNames[0];//alert(Name1);
                        if(status == 1){
                            var uname = ArrNames[1];
                            var uemail = ArrNames[2];
                            var fname = ArrNames[3];
                            var lname = ArrNames[4];
                            var uid = ArrNames[5];
                            let praferance = '';
                           
                            var tenant_id = ArrNames[6];
                            if(uname != ''){
                                $.cookie('wps_uname', uname, {expires: 7 , path: '/'});
                            }
                            if(uemail != ''){
                                $.cookie('wps_uemail', uemail, {expires: 7 , path: '/'});
                            }
                            if(fname != ''){
                                $.cookie('wps_fname', fname, {expires: 7 , path: '/'});
                            }
                            if(lname != ''){
                                $.cookie('wps_lname', lname, {expires: 7 , path: '/'});
                            }
                            if(uid != ''){
                                $.cookie('wps_uid', uid, {expires: 7 , path: '/'},);
                                $.cookie('wps_tenant_id', tenant_id, {expires: 7 , path: '/'},);

                                var settings = {
                                    "url": "https://sso.sportsalliance.com/v5/users/" + uid,
                                    "method": "GET",
                                    "timeout": 0,
                                    "headers": {
                                        "Accept": "application/json",
                                        "Authorization": "basic MTQxYjYwOTc1M2Y0NGU1NThlNTMyOWE5MDgzZDFiOGY6VjdGYklhRVVoVlJuQUJGY1ZWOXBLVEk4VEFCdWF6S21lRjN5eVM4YnNJRQ=="
                                    },
                                };
                            
                                $.ajax(settings).done(function (response) {
                                    const optInEmailWomens = response.Permissions.find(permission => permission.Name === "OptInEmailWomens");
                            
                                    if (optInEmailWomens) {
                                        // Get the Preference value
                                        const preferenceValue = optInEmailWomens.Preference;
                                        praferance = preferenceValue ? "women" : "men";
                                        // console.log('Praferance:', praferance);
                            
                                        // Now set the cookie and add the class to the body
                                        $.removeCookie('wps_praferance_all', { path: '/' });
                                        $.cookie('wps_praferance', praferance, { expires: 7, path: '/' });
                                        $('body').addClass(`praferance-${praferance}`);
                                        

                                        var last_visit = $.cookie("last_visit");
                                        if(last_visit != ''){
                                            
                                            window.location.href = $.cookie("last_visit");
                                        }
                                    } else {
                                        console.log("OptInEmailWomens permission not found.");
                                        var last_visit = $.cookie("last_visit");
                                            if(last_visit != ''){
                                                
                                                window.location.href = $.cookie("last_visit");
                                            }
                                    }
                                }).fail(function () {
                                    console.error('Failed to fetch user preferences.');
                                });
                            }
                            
                            
                            
                        }
                        
                    }
                }
            });
        }
    }
    if($('.logouts').length > 0){
        $('.logouts').on('click', function(e) {
            $.removeCookie("wps_uname", { path: '/' });
            $.removeCookie("wps_fname", { path: '/' });
            $.removeCookie("wps_uemail", { path: '/' });
            $.removeCookie("wps_lname", { path: '/' });
            $.removeCookie("wps_uid", { path: '/' });
            $.removeCookie("wps_tenant_id", { path: '/' });
            var last_visit = $.cookie("last_visit");
            if(last_visit != ''){
                
                window.location.href = $.cookie("last_visit");
            }
        });
    }
    if(ssAjax.cpageID != ssAjax.exclude_id && ssAjax.cpageID != ssAjax.exclude_id2){
        $.cookie('last_visit', ssAjax.cpageUrl, {expires: 1 , path: '/'});
    }
    // var is_login = $.cookie("wps_uid");
    // if(is_login != ''){
    //     var number = Math.floor(100000 + Math.random() * 900000);
    //     $.cookie('wps_uid', number, {expires: 1 , path: '/'});
    // }
    const storedPraferance = $.cookie('wps_praferance');
    if (storedPraferance) {
        $('body').addClass(`praferance-${storedPraferance}`);

        if (storedPraferance === 'women') {
            
            toggleSliders(storedPraferance === 'women' ? 'women' : 'men');
            $('#f').prop('checked', true);
            $('#ticketscheck').prop('checked', true);
            $('#standingpoint').prop('checked', true);
            
            if($('.fixtures-detail').length > 0){
                $(".fixtures-right-tab").removeClass('active');
                $("#women").addClass('active');
                $(".fixtures-right-tab-content").removeClass('active');
                $("#women-content").addClass("active");
                $('.fixtures-right-tab#women').click();

                $('.fixtures-table-tab').removeClass('active');
                $('#womenTable').addClass('active');
                $('.table-tab-detail-innerx').removeClass('active');
                $('#womenTable-content').addClass('active');
                //results tab fixture
                $(".fixtures-results-tab").removeClass('active');
                $(".fixtures-results-tab[data-id='women']").addClass('active');
                $(".fixtures-results-tab[data-id='women']").click();
                //match report
                $(".fixtures-men-women-tab-content").removeClass('active');
                $(".fixtures-men-women-tab").removeClass('active');
                $('#fixtures4-women').addClass('active');
                $('#fixtures4-women-content').addClass('active');
            }
            if($('.player-tab-list').length > 0){
                $('.player-list').removeClass('active');
                $('.player-tab-list-content').removeClass('active');
                $('#womens').addClass('active');
                $('#womens-content').addClass('active');
            }
            if($('.match-list-men-women-section').length > 0){
                $('.match-list-tab').removeClass('active');
                $('.match-list-tab-content').removeClass('active');
                $('#womenTable').addClass('active');
                $('#womenTable-content').addClass('active');
            }
            if($('.match-center-live-box').length > 0){
                $('#g').prop('checked', true);
            }
            
        } else {
            $('#f').prop('checked', false); // Default to 'man' or unchecked
            $('#ticketscheck').prop('checked', false);
            // toggleticketsSliders('men');
            $('#standingpoint').prop('checked', false);
            if($('.fixtures-detail').length > 0){
                $(".fixtures-right-tab").removeClass('active');
                $("#men1").addClass('active');
                $(".fixtures-right-tab-content").removeClass('active');
                $("#men1-content").addClass("active");
                $('.fixtures-right-tab#men1').click();
                $('.fixtures-table-tab').removeClass('active');
                $('#menTable').addClass('active');
                $('.table-tab-detail-innerx').removeClass('active');
                $('#menTable-content').addClass('active');
                //results tab fixture
                $(".fixtures-results-tab").removeClass('active');
                $(".fixtures-results-tab[data-id='men']").addClass('active');
                $(".fixtures-results-tab[data-id='men']").click();

                //match report
                $(".fixtures-men-women-tab-content").removeClass('active');
                $(".fixtures-men-women-tab").removeClass('active');
                $('#fixtures4-men').addClass('active');
                $('#fixtures4-men-content').addClass('active');
            
            }
            if($('.player-tab-list').length > 0){
                $('.player-list').removeClass('active');
                $('.player-tab-list-content').removeClass('active');
                $('#men').addClass('active');
                $('#men-content').addClass('active');
            }
            if($('.match-list-men-women-section').length > 0){
                $('.match-list-tab').removeClass('active');
                $('.match-list-tab-content').removeClass('active');
                $('#menTable').addClass('active');
                $('#menTable-content').addClass('active');
            }
        }        // toggleSliders(storedPraferance === 'women' ? 'women' : 'men');
        // On checkbox change, perform actions (but don't modify the cookie)        
    }
    else{
        $('.preference-popup-overlay').show();
        
    }
    if(window.location.pathname === '/buy-tickets/womens/' && window.location.pathname !== '/buy-tickets/'){
        $('#ticketscheck').prop('checked', true);
        toggleticketsSliders('women');
    }
    if(window.location.pathname === '/buy-tickets/' && window.location.pathname !== '/buy-tickets/womens/'){
        $('#ticketscheck').prop('checked', false);
        toggleticketsSliders('men');
    }
    $(document).on('click','#prefclose',function() {
        $('.preference-popup-overlay').hide();
        $.cookie('wps_praferance', 'men', { expires: 7, path: '/' });
        $.removeCookie('wps_praferance_all', { path: '/' });
        location.reload();
    });
    $(document).on('click','#prefmen',function() {
        $('.preference-popup-overlay').hide();
        $.cookie('wps_praferance', 'men', { expires: 7, path: '/' });
        $.removeCookie('wps_praferance_all', { path: '/' });
        
        location.reload();
    });
    $(document).on('click','#prefall',function() {
        $('.preference-popup-overlay').hide();
        $.cookie('wps_praferance', 'men', { expires: 7, path: '/' });
        $.cookie('wps_praferance_all', 'all', { expires: 7, path: '/' });
        location.reload();
    });
    $(document).on('click','#prefwomen',function() {
        $('.preference-popup-overlay').hide();
        $.cookie('wps_praferance', 'women', { expires: 7, path: '/' });
        $.removeCookie('wps_praferance_all', { path: '/' });
        location.reload();        
    });

    $(document).on('change','#g',function () {
        var category = $(this).is(':checked') ? 'women' : 'men';
        $('.live-match').each(function() {
            if ($(this).attr('data-type') === category) {
                $(this).show();
            } else {
                $(this).hide();
            }
        }); 
    });

    $(document).on('change', '#f', function(e) {
        var category = $(this).is(':checked') ? 'women' : 'men';
        toggleSliders(category);
    });
    function toggleSliders(category) {
        
        if($('.player-slider')[0]) {
        
            if (category === 'women') {
                $('#men-player').fadeOut(300, function () {
                    $('#women-player').slick('refresh');
                $('#women-player').fadeIn(300);
                
                });
            } else {
                $('#women-player').fadeOut(300, function () {
                    $('#men-player').slick('refresh');
                    $('#men-player').fadeIn(300);
                });
                
            }
        }
    }
    function toggleticketsSliders(category) {
        $.ajax({
            type: "POST",
            cache: false,
            url: ssAjax.ajaxurl,
            data: { nonce: ssAjax.nonce, user_preference:category, action: 'get_season_tickets' },
            // dataType: 'html',
            beforeSend: function () {
                // Optional: Show a loader
                $('.tickets-slider-main').html('<p>Loading...</p>');
            },
            success: function (response) {
                if (response.success) {
                    // Update the tabs
                    // $('#sesiontab').html('');
                    $('#sesiontab').html(response.data.tabs);
                    // $('#tickets-sliderx').html('');
                    // Update the slider content
                    $('#tickets-sliderx').html(response.data.slider);
                    $(".get-list").click(function () {
                        if ($(this).hasClass('active')) {
                        } else {
                          var tabid = $(this).attr('id');
                          $(".get-list").removeClass('active');
                          $(this).addClass('active');
                          $(".get-list-content").removeClass('active');
                          $("#" + tabid + "-content").addClass("active");
                        }
                        return false;
                    });
                    // Reinitialize the slider
                    $('.get-ticket-slider').slick({
                        dots:false,
                        infinite: false,
                        speed: 600,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '120px',
                        autoplay:false,
                        autoplaySpeed: 2000,
                        arrows:true,
                        responsive: [
                            {
                                breakpoint: 1023,
                                settings: {
                                slidesToShow: 1,
                                centerPadding: '20px',
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                slidesToShow: 1,
                                centerPadding: '0px',
                                }
                            },
                        
                            ]
                    });
                } else {
                    console.error('Failed to load data');
                }
            },
            error: function () {
                console.error('Error in AJAX request');
            },
        });
    }
    $('#ticketscheck').change(function () {
        // alert('ih');
        var category = $(this).is(':checked') ? 'women' : 'men';
        // AJAX Request
        toggleticketsSliders(category)
        
    });
    $('#standingpoint').change(function () {
        var category = $(this).is(':checked') ? 'women' : 'men';
        $('.tab-list-content, .tab-list').hide();
        $('.tab-list[data-type="' + category + '"]').show();
        $('.tab-list-content[data-type="' + category + '"]').first().show();
        
    });
    
    $(".pathway-tab").click(function () {
        if ($(this).hasClass('active')) {
        } else {
          var tabid = $(this).attr('id');
          $(".pathway-tab").removeClass('active');
          $(this).addClass('active');
          $(".pathway-tab-content").removeClass('active');
          $("#" + tabid + "-content").addClass("active");
        }
        return false;
    });
    $(".player-statistics-tab").click(function () {
        if ($(this).hasClass('active')) {
        } else {
          var tabid = $(this).attr('id');
          $(".player-statistics-tab").removeClass('active');
          $(this).addClass('active');
          $(".player-statistics-tab-content").removeClass('active');
          $("#" + tabid + "-content").addClass("active");
        }
        return false;
    });

    $(".fixtures-tables-tab-one").click(function () {
        if ($(this).hasClass('active')) {
        } else {
          var tabid = $(this).attr('id');
          $(".fixtures-tables-tab-one").removeClass('active');
          $(this).addClass('active');
          $(".tab-list-content").removeClass('active');
          $("#all-match-new-" + tabid + "-content").addClass("active");
        }
        return false;
    });
    $(".match-list-tab").click(function () {
        if ($(this).hasClass('active')) {
        } else {
          var tabid = $(this).attr('id');
          $(".match-list-tab").removeClass('active');
          $(this).addClass('active');
          $(".match-list-tab-content").removeClass('active');
          $("#" + tabid + "-content").addClass("active");
        }
        return false;
    });

    $('.match-tab-list ul li a.match-scroll').on('click',function (e) {
        var target = this.hash,
            $target = $(target);
      
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top-70
        }, 900, 'swing', function () {
            window.location.hash = target;
        });        
    });

    $(".player-statistics-select select").change(function(){
        $(this).find("option:selected").each(function(){
            var optionValue = $(this).attr("value");
            if(optionValue){
                $(".player-statistics-bottom").not("." + optionValue).hide();
                $("." + optionValue).show();
            } else{
                $(".player-statistics-bottom").hide();
            }
        });
    }).change();

    $(".site-search-wrapper li a.search-icon").click(function(){
        $("body").css("overflow","hidden");
        $('.search-box-menu').show();
        $(".search-screen").addClass("active");
        return false;
    });
    $(".search-tab li a.gird-all").click(function(){
        $(".search-tab li a").removeClass("active");
        $(this).addClass("active");
        $(".search-tab-detail-box.gird-all").addClass("active");
        return false;
    });
    
    $(".search-tab li a.grid-new").click(function(){
        $(".search-tab li a").removeClass("active");
        $(this).addClass("active");
        $(".search-tab-detail-box").removeClass("active");
        $(".search-tab-detail-box.grid-new").addClass("active");
        return false;
    });
    $(".search-tab li a.grid-players").click(function(){
        $(".search-tab li a").removeClass("active");
        $(this).addClass("active");
        $(".search-tab-detail-box").removeClass("active");
        $(".search-tab-detail-box.grid-players").addClass("active");
        return false;
    });
    $(".search-tab li a.grid-videos").click(function(){
        $(".search-tab li a").removeClass("active");
        $(this).addClass("active");
        $(".search-tab-detail-box").removeClass("active");
        $(".search-tab-detail-box.grid-videos").addClass("active");
        return false;
    });
    $(".search-tab li a.grid-pager").click(function(){
        $(".search-tab li a").removeClass("active");
        $(this).addClass("active");
        $(".search-tab-detail-box").removeClass("active");
        $(".search-tab-detail-box.grid-pager").addClass("active");
        return false;
    });

    // Remove Active Class
    $(".close-icon").click(function(){
      $("body").css("overflow","auto");
      $('.search-box-menu').hide();
        $(".search-screen").removeClass("active");
    });
    if ($('.page-id-61029').length > 0) {
    
        $('.hideserch').show('');
    }
    if ($('body.search-results').length > 0) {
    
        $('.hideserch').hide('');
    }
    if ($('body.search-no-results').length > 0) {
    
        $('.hideserch').hide('');
    }

    $("#search").keyup(function(){
        if ($(this).val().length > 2) {
            let serchval = $(this).val();
            $.ajax({
                type: "POST",
                cache: false,
                url: ssAjax.ajaxurl,
                data: { nonce: ssAjax.nonce, serchval:serchval, action: 'getserchdata' },
                dataType: 'html',
                success: function (response) {
                // console.warn(response);
                    // $("#loaders").fadeOut();
                    // $("#datapritn").html("");
                    // $("#datapritn").html(response);
                    $('#datafetch').show('');
                    $('#defult').fadeOut('');
                    $('#datafetch').html( response );
                   
                }
            });
        }
        else{
            $('#datafetch').html('');
            $('#datafetch').hide('');
            $('#defult').fadeIn('');
            
        }
    } );

    if($( "#datafetch" ).length>0){
        $( "#datafetch" ).text( "  No Match Found  " ).addClass('remove');

        $( "#datafetch" ).ready(function(){
            $(this).find(".remove").removeClass('remove');
        });
    }
  } )( jQuery );    
} )();

document.addEventListener("DOMContentLoaded", function() {
    AOS.init({
        duration: 800,
        delay: 10,
        once: true,
        useClassNames: true,
        initClassName: false,
    });

    let scrollRef = 0;
    
    window.addEventListener('scroll', function() {
      scrollRef <= 10 ? scrollRef++ : AOS.refresh();
    });
});